// extracted by mini-css-extract-plugin
export default {"benefits":"ZmHP8","benefit":"dihnj"};